<app-header class="mb-2"></app-header>
<div id="main-container">
  <div id="div-info-content">
    <div class="container margin-top">
      <router-outlet></router-outlet>
    </div>
  </div>
  <br><br>
</div>
<div id="div-footer">
  <app-footer></app-footer>
</div>
<app-loading *ngIf="loading"></app-loading>
